import { isBrowser } from "../../utils/browser"

// Visit any page with ?crashTest=throwTestError to throw inside the ErrorBoundary tree,
// for verifying the Bugsnag/logger/fallback-UI pipeline end-to-end (e.g. in production).
export const CrashTest = () => {
    if (isBrowser && new URLSearchParams(window.location.search).get("crashTest") === "throwTestError") {
        throw new Error("Bugsnag crash test triggered via ?crashTest=throwTestError")
    }
    return null
}
